import moment from 'moment'
var now  = moment().format('DD/MM/YYYY HH:mm:ss');

let isOverTime = false;

const productionTimeCount = (timeFromDevice) => {
var startFrom = moment.utc(timeFromDevice).local().format('DD/MM/YYYY HH:mm:ss');
var ms = moment(now,"DD/MM/YYYY HH:mm:ss").diff(moment(startFrom,"DD/MM/YYYY HH:mm:ss"));
let timeRunning = ms / 1000;
// isOverTime = timeRunning > 600;
isOverTime = timeRunning > 30;
var d = moment.duration(ms);
var countUp = d.format('YY [years]. MM [months], DD [days] HH [hours] mm [minutes] ss [second]');
return [countUp, isOverTime]
}

export default productionTimeCount;